export default ["regular", "emv"]
